import {
  FETCH_VIDEO_REQUEST,
  FETCH_VIDEO_SUCCESS,
  FETCH_VIDEO_FAILURE,
  FETCH_VIDEO_WARNING,
  UPDATE_CURRENT_TIME,
  DISMISS_ERROR,
  LOADING_VIDEO,
  REMOVE_EXISTENT_VIDEO,
} from '../actions/video'
import { LOGIN_SUCCESS } from '../actions/login'
import { LOGOUT_SUCCESS } from '../actions/logout'
import { PAY_NOW_SUCCESS } from '../actions/checkout'

const INITIAL_STATE = {
  isReady: false,
  hasError: false,
  errorMessage: '',
  video: null,
  loading: false,
}

const videoReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
    case LOGOUT_SUCCESS:
    case PAY_NOW_SUCCESS:
    case DISMISS_ERROR:
      return {
        ...INITIAL_STATE,
      }

    case FETCH_VIDEO_REQUEST:
      return {
        ...state,
        isReady: false,
        hasError: false,
        errorMessage: '',
        video: {
          id: -1,
          currentTime: 0,
        },
      }
    case FETCH_VIDEO_SUCCESS:
      return {
        ...state,
        isReady: true,
        hasError: false,
        loading: false,
        errorMessage: '',
        video: {
          ...action.payload,
          lastUpdated: Date.now(),
        },
      }
    case FETCH_VIDEO_WARNING:
      return {
        ...state,
        video: {
          ...state.video,
          lastUpdated: Date.now(),
        },
      }
    case FETCH_VIDEO_FAILURE:
      return {
        ...state,
        isReady: true,
        hasError: true,
        loading: false,
        errorMessage: action.payload.message,
      }

    case UPDATE_CURRENT_TIME:
      return {
        ...state,
        video: {
          ...state.video,
          currentTime: action.payload.currentTime,
        },
      }
    case LOADING_VIDEO:
      return {
        ...state,
        loading: true,
      }
    case REMOVE_EXISTENT_VIDEO:
      return {
        ...state,
        video: null,
      }

    default:
      return state
  }
}

export default videoReducer
